export const AUTH_LOGIN_BEGIN = "AUTH_LOGIN_BEGIN"
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS"
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE"
export const AUTH_LOGIN_DISMISS_ERROR = "AUTH_LOGIN_DISMISS_ERROR"
export const AUTH_LOGOUT = "AUTH_LOGOUT"
export const AUTH_FETCH_USERINFO_BEGIN = "AUTH_FETCH_USERINFO_BEGIN"
export const AUTH_FETCH_USERINFO_SUCCESS = "AUTH_FETCH_USERINFO_SUCCESS"
export const AUTH_FETCH_USERINFO_FAILURE = "AUTH_FETCH_USERINFO_FAILURE"
export const AUTH_FETCH_USERINFO_DISMISS_ERROR = "AUTH_FETCH_USERINFO_DISMISS_ERROR"



// WEBPACK FOOTER //
// ./src/features/auth/redux/constants.js